import Vue from 'vue'
import App from './App.vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
import VueScrollTo from 'vue-scrollto';
import VueParticles from 'vue-particles'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faLinkedin } from '@fortawesome/free-brands-svg-icons'
import vuetify from './plugins/vuetify';

library.add(faFacebook)
library.add(faLinkedin)
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false
Vue.use(VueScrollTo)
Vue.use(VueParticles)


new Vue({
  created () {
    AOS.init()
  },

  vuetify,
  render: h => h(App)
}).$mount('#app')



